import { CertBadge } from "./CertBadge"

interface CertSuccessProps {
  certNumber: string
  domain: string
}

export const CertSuccess = ({ certNumber, domain }: CertSuccessProps) => {
  return (
    <div className="text-center space-y-4 bg-white/5 backdrop-blur-lg rounded-lg p-6">
      <div className="text-xl font-bold text-white">
        您的备案号: {certNumber}
      </div>
      <CertBadge 
        certNumber={certNumber}
        domain={domain}
      />
    </div>
  )
}